<template>
  <div class="pa-4">
    <div v-if="loading" class="text-center">
      <v-skeleton-loader type="list-item-avatar, divider, article, actions"></v-skeleton-loader>
    </div>
    <div v-else class="text-center">
      <v-card class="bjjlink-card" v-if="transaction && transaction.items && academy" elevation="0" outlined>
        <v-card-title class="mb-0 pb-0">
          <v-icon>mdi-cart-outline</v-icon> {{ $t("message.items") }} ({{ transaction.items.length }})
        </v-card-title>
        <v-list dense>
          <template v-for="(i, index) in transaction.items">
            <v-list-item v-if="i.product" :key="'item' + index" class="text-left">
              <v-list-item-avatar outlined size="30">
                <v-badge v-if="i.product.color" bordered bottom size="50" :color="i.product.color" offset-x="35"
                  offset-y="15">
                  <v-avatar color="grey lighten-4">
                    <ImageDisplay v-if="i.product.image" :src="i.product.image" />
                    <img v-else :src="assets('logo-circular-watermarked.png')" />
                  </v-avatar>
                </v-badge>
                <v-avatar v-else color="grey lighten-4">
                  <ImageDisplay v-if="i.product.image" :src="i.product.image" />
                  <img v-else :src="assets('logo-circular-watermarked.png')" />
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ i.product.name }} -
                  <span class="title-amount">
                    {{ academy.currencySymbol + (i.amount ? string2Decimal(i.amount) : i.product.amountDecimal)
                    }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle v-if="i.product.size">{{ i.product.size }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                {{ i.quantity }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-else :key="'item' + index" class="text-left">
              <v-list-item-avatar>
                <v-avatar size="50" color="grey lighten-4">
                  <ImageDisplay v-if="transaction.event && transaction.event.image" :src="transaction.event.image" />
                  <img v-else :src="assets('logo-circular-watermarked.png')" />
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ i.name }} -
                  <span class="title-amount">
                    {{ academy.currencySymbol + (i.amountDecimal ? i.amountDecimal : i.amount) }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle v-html="i.description">
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                {{ i.quantity }}
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < transaction.items.length" :key="index"></v-divider>
          </template>
        </v-list>
        <div class="text-left pl-2 pb-2">
          <span>TOTAL: {{ academy.currencySymbol }}{{ transactionTotal }}</span>
          <span v-if="transaction.coupon">
            <span class="ml-1">-</span>
            <v-icon class="ml-1" size="15" color="accent">mdi-tag-outline</v-icon>
            <span v-if="transaction.coupon.discountPercent">{{ transaction.coupon.discountPercent }}%</span>
            <span class="ml-1" v-else>{{ academy.currencySymbol }}{{ transaction.coupon.discountAmount }}</span>
            <span class="ml-1">=</span>
            <span class="ml-1">{{ academy.currencySymbol }}{{ transaction.coupon.discountedTotal }}</span>
          </span>
        </div>
      </v-card>
      <v-card class="mt-2" v-if="transaction && academy" elevation="0" outlined>
        <v-list class="text-left">
          <v-list-item dense>
            <v-list-item-action>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $d(new Date(created), "long", $i18n.locale) }}
                <v-btn class="ml-1" v-if="transaction.paidWithCash" small icon @click="transactionDateDialog = true">
                  <v-icon size="20">mdi-calendar-edit-outline</v-icon>
                </v-btn>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.date") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="transaction.user" dense>
            <v-list-item-action>
              <v-icon>mdi-account-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ transaction.user.fName }} {{ transaction.user.lName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.processed_by") }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar v-if="transaction.user.userImageSmall" size="30">
              <ImageDisplay :src="transaction.user.userImageSmall" />
            </v-list-item-avatar>
          </v-list-item>
          <v-list-item v-if="transaction.event && transaction.event.title" dense @click="goToEvent(transaction.event)">
            <v-list-item-action>
              <v-icon>mdi-calendar-star</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ transaction.event.title }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.event") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="transaction.buyer" dense @click="checkMemberAndGo()">
            <v-list-item-action>
              <v-icon>mdi-account-check-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <span>{{
                  transaction.buyer
                    ? transaction.buyer.fName + " " + transaction.buyer.lName
                    : transaction.email
                }}</span>
                <v-btn small icon @click.stop="assignBuyerDialog = true">
                  <v-icon size="20">mdi-pencil-box-outline</v-icon>
                </v-btn>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.sold_to") }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar v-if="transaction.buyer.userImageSmall" size="30">
              <ImageDisplay :src="transaction.buyer.userImageSmall" />
            </v-list-item-avatar>
          </v-list-item>
          <v-list-item v-else>
            <v-list-item-action>
              <v-icon>mdi-account-check-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-btn small text @click.stop="assignBuyerDialog = true">
                  {{ $t('message.assign_buyer') }}
                </v-btn>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.sold_to") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-action>
              <TransactionIcon :status-color="getStatusColor(transaction)" size="20" :transaction="transaction">
              </TransactionIcon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ getPaymentStatus() }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.status") }} {{ transaction.status }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="transaction.status == 'pending_payment'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" :loading="sendingReminder" icon @click="sendReminder()">
                    <v-icon>mdi-email-fast-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('message.send_reminder') }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-list-item dense v-if="!paymentsReady">
            <v-list-item-action>
              <PaymentType size="20" :type="transaction.paidWith"></PaymentType>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ transaction.paidWith ? $t("message." + transaction.paidWith) : $t("message.cash") }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.paid_with") }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small icon @click="editPaidWithDialog = true"><v-icon>mdi-square-edit-outline</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item dense v-if="transaction.cancelled">
            <v-list-item-action>
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $d(new Date(transaction.cancelled), "long", $i18n.locale) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.cancelled_on") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense v-if="transaction.coupon">
            <v-list-item-action>
              <v-icon>mdi-tag-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <span class="text-body-2" v-if="transaction.coupon.discountPercent">
                  {{ transaction.coupon.discountPercent }}%
                </span>
                <span class="text-body-2" v-if="transaction.coupon.discountAmount">
                  {{ academy.currencySymbol }}{{ transaction.coupon.discountAmount }}
                </span>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.discount") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-title class="mt-0 pt-0">
          <div class="text-subtitle-1 font-weight-bold mr-2">Total:</div>
          <span v-if="transaction.coupon" class="text-body-2">
            {{ academy.currencySymbol }}{{ transaction.coupon.discountedTotal }}
          </span>
          <span v-else class="text-body-2">{{ academy.currencySymbol }}{{ amount * transaction.quantity }}</span>
        </v-card-title>
        <v-card-title class="mt-0 pt-0 text-subtitle-1 text-left" v-if="!isNaN(transaction.taxAmount)">
          <span class="mr-1 ml-1 text-body-2">{{ $t("message.tax") }}:</span>
          <span class="text-body-2">{{ academy.currencySymbol }}{{
            transaction.taxAmount
          }}</span>
        </v-card-title>
        <v-card-title class="mt-0 pt-0 text-subtitle-1 text-left"
          v-else-if="checkoutSession && checkoutSession.automaticTax">
          <span class="mr-1 ml-1 text-body-2">{{ $t("message.tax") }}:</span>
          <span class="text-body-2">{{ academy.currencySymbol }}{{
            centsToAmount(checkoutSession.totalDetails.amount_tax)
          }}</span>
        </v-card-title>
        <v-card-text v-if="transaction.refunds && transaction.refunds.length > 0"
          class="text-left error--text ml-2 mt-0 pt-0">
          <div class="text-subtitle-1 font-weight-bold mr-2">{{ $t("message.refunds") }}</div>
          <div class="text-body-2" v-for="(r, index) in transaction.refunds" :key="'refund' + index">{{ $d(new
            Date(r.date), "long",
            $i18n.locale) }}: {{ r.user.displayName }} - {{ r.amount }} {{ currency }}</div>
        </v-card-text>
        <v-card-title v-if="totalRefunded > 0" class="mt-0 pt-0">
          <div class="text-subtitle-1 font-weight-bold mr-2">Final Total:</div>
          <span v-if="transaction.coupon" class="text-body-2">
            {{ academy.currencySymbol }}{{ transaction.coupon.discountedTotal - totalRefunded }}
          </span>
          <span v-else class="text-body-2">{{ academy.currencySymbol }}{{ (amount * transaction.quantity) -
            totalRefunded
            }}</span>
        </v-card-title>
      </v-card>
      <v-expansion-panels class="mt-2" flat>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon
                :color="transaction.notes && transaction.notes != '' ? 'accent' : ''">mdi-message-text-outline</v-icon>
              {{ $t("message.notes") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-textarea filled :placeholder="$t('message.type_to_edit')" v-model="transaction.notes"></v-textarea>
            <v-card-actions class="mt-0 pt-0">
              <v-btn elevation="0" small outlined color="primary" @click="updateTransactionNotes()">
                {{ $t("message.update") }}
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="history && history.length > 0"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header class="text-left ml-1">
            <div>
              <v-icon>mdi-clock-outline</v-icon>
              {{ $t("message.history") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <AcademyActivity :activity="history"></AcademyActivity>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon :color="receipt ? 'accent' : ''">mdi-receipt-text</v-icon>
              {{ $t("message.upload_receipt") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-actions>
              <v-btn v-if="!uploadedReceipt" :disabled="uploading" outlined class="elevation-0" @click="filePicker()"
                color="primary" small>
                <v-icon>mdi-receipt-text-outline</v-icon>
                {{ $t("message.upload_receipt") }}
              </v-btn>
              <v-btn v-else :disabled="uploading" outlined class="elevation-0" @click="updateTransactionReceipt()"
                color="primary" small>
                {{ $t("message.update") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="receipt" class="elevation-0" @click="receipt = null;" color="error" small dark>
                <v-icon>mdi-trash-can-outline</v-icon>
                {{ $t("message.delete") }}
              </v-btn>
            </v-card-actions>
            <v-progress-linear v-if="uploading" indeterminate color="secondary"></v-progress-linear>
            <v-card-text v-if="receipt">
              <v-responsive>
                <ImageDisplay :src="receipt" />
              </v-responsive>
            </v-card-text>
            <v-card-text>
              <div v-if="uploadingMessage">
                {{ uploadingMessage }}
              </div>
              <input style="display: none" type="file" accept="image/*" @change="onFileSelect" ref="fileUploadInput" />
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card class="mt-2" v-if="transaction.paidWithCash" elevation="0" outlined>
        <v-card-actions>
          <v-btn elevation="0" v-if="transaction.event" @click="goToEvent(transaction.event)" style="margin-left:5px"
            class="supporting-text clickable">
            <v-icon>mdi-account-minus-outline</v-icon>
            {{ $t("message.remove_from_event") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small elevation="0" color="error" @click="cancelCashTransactionDialog = true">
            <v-icon>mdi-trash-can-outline</v-icon>
            <span v-if="!isSmallerDisplay()">{{ $t("message.cancel_transaction") }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-2" elevation="0" v-if="!transaction.cancelled">
        <v-card-actions v-if="!isSmallerDisplay()">
          <v-btn outlined elevation="0" small v-if="canCompletePayment()" @click="completePayment()"
            :disabled="processingPayment" color="primary">
            <v-icon v-if="!processingPayment">mdi-credit-card-check-outline</v-icon>
            <v-icon class="rotate" v-else>mdi-refresh</v-icon>
            {{ $t("message.complete_payment") }}
          </v-btn>
          <v-btn outlined small elevation="0" color="primary"
            v-if="paymentMethod && !paymentMethod.expired && canCompletePayment()" :disabled="processingPayment"
            @click="completePaymentSavedCard()">
            <v-icon v-if="!processingPayment">mdi-wallet-outline</v-icon>
            <v-icon class="rotate" v-else>mdi-refresh</v-icon> {{ $t('message.pay_saved_card') }}
          </v-btn>
          <v-btn outlined small elevation="0" color="primary" :disabled="processingPayment" v-if="canCompletePayment()"
            @click="completePaymentCash()">
            <v-icon v-if="!processingPayment">mdi-cash-check</v-icon>
            <v-icon class="rotate" v-else>mdi-refresh</v-icon> {{ $t('message.pay_cash') }}
          </v-btn>
          <v-btn
            v-if="transaction.completed && !transaction.paidWithCash && selectedInvoice && totalAmount > totalRefunded"
            elevation="0" small outlined color="primary" @click="showRefundDialog()">
            <v-icon>mdi-credit-card-refund-outline</v-icon>
            {{ $t("message.refund") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small elevation="0" color="error" @click="!transaction.completed && cancelOneTimePayment()"
            v-if="!transaction.cancelled && !transaction.completed">
            <v-icon>mdi-trash-can-outline</v-icon>
            {{ $t("message.cancel") }}
          </v-btn>
        </v-card-actions>
        <div v-else>
          <v-btn outlined block elevation="0" small v-if="canCompletePayment()" :disabled="processingPayment"
            @click="completePayment()" color="primary">
            <v-icon v-if="!processingPayment">mdi-credit-card-check-outline</v-icon>
            <v-icon class="rotate" v-else>mdi-refresh</v-icon>
            {{ $t("message.complete_payment") }}
          </v-btn>
          <v-btn outlined class="mt-2" block small elevation="0" color="primary" :disabled="processingPayment"
            v-if="paymentMethod && !paymentMethod.expired && canCompletePayment()" @click="completePaymentSavedCard()">
            <v-icon v-if="!processingPayment">mdi-wallet-outline</v-icon>
            <v-icon class="rotate" v-else>mdi-refresh</v-icon>
            {{ $t('message.pay_saved_card') }}
          </v-btn>
          <v-btn outlined class="mt-2" block small elevation="0" color="primary" :disabled="processingPayment"
            v-if="canCompletePayment()" @click="completePaymentCash()">
            <v-icon v-if="!processingPayment">mdi-cash-check</v-icon>
            <v-icon class="rotate" v-else>mdi-refresh</v-icon>
            {{ $t('message.pay_cash') }}
          </v-btn>
          <v-btn class="mt-2" block
            v-if="transaction.completed && !transaction.paidWithCash && selectedInvoice && totalAmount > totalRefunded"
            elevation="0" small outlined color="primary" @click="showRefundDialog()">
            <v-icon>mdi-credit-card-refund-outline</v-icon>
            {{ isInfinicept ? $t("message.void") : $t("message.refund") }}
          </v-btn>


          <v-btn class="mt-2" block small elevation="0" color="error"
            @click="!transaction.completed && cancelOneTimePayment()"
            v-if="!transaction.cancelled && !transaction.completed">
            <v-icon>mdi-trash-can-outline</v-icon>
            {{ $t("message.cancel") }}
          </v-btn>
        </div>
      </v-card>
      <v-card class="bjjlink-card" elevation="0">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" small @click="goBack()">
            {{ $t("message.back") }}
          </v-btn>
          <v-btn elevation="0" small @click="sendEmailDialog = true">
            {{ $t("message.email") }}
          </v-btn>
          <v-btn v-if="!isSmallerDisplay()" elevation="0" small @click="printReceipt()">
            {{ $t("message.print") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="cancelCashTransactionDialog" width="90%">
      <v-card>
        <v-card-title>
          {{ $t("message.remove") }} {{ $t("message.transaction") }}
        </v-card-title>
        <v-card-text>
          <h3>{{ $t("message.are_you_sure") }}</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="error" @click="removeCashTransaction()">{{
            $t("message.remove")
            }}</v-btn>
          <v-btn small elevation="0" color="secondary" @click="cancelCashTransactionDialog = false">{{
            $t("message.close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendEmailDialog" width="90%" pa-1>
      <v-card>
        <v-card-title>
          <h2>{{ $t("message.email_receipt") }}</h2>
        </v-card-title>
        <v-card-title>
          <v-switch v-model="altEmailConfirm" :label="$t('message.use_different_email')"></v-switch>
        </v-card-title>
        <v-card-title>
          <v-text-field :disabled="!altEmailConfirm" single-line outline :label="$t('message.email')"
            v-model="altEmail"></v-text-field>
        </v-card-title>
        <v-card-actions>
          <v-btn outlined :disabled="false" color="primary" @click="emailReceipt()">{{
            $t("message.email")
            }}</v-btn>
          <v-btn @click="sendEmailDialog = false">{{
            $t("message.close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transactionDateDialog" max-width="90%">
      <v-card v-if="transaction" outlined>
        <v-card-title class="text-title">
          {{ $t('message.date') }}
        </v-card-title>
        <v-card-text class="text-subtitle-1">
          <DatePicker :past-event="true" v-model="created"></DatePicker>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="primary" @click.stop="updateTransactionDate()">{{ $t('message.update')
            }}</v-btn>
          <v-btn class="outlined-btn" small elevation="0" @click.stop="transactionDateDialog = false">{{
            $t('message.close')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignBuyerDialog" width="90%" pa-1>
      <v-card outlined>
        <v-card-title>
          {{ $t("message.assign_buyer") }}
        </v-card-title>
        <v-card-text>
          <members-autocomplete :label="$t('message.member')" v-model="assignMemberId" />
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" small color="primary" @click="assignBuyer()">OK</v-btn>
          <v-btn elevation="0" small @click="assignBuyerDialog = false;">
            {{ $t("message.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="refundConfirmDialog" max-width="600">
      <v-card style class="text-xs-left pa-3">
        <v-card-title>{{ $t('message.refund') }}</v-card-title>
        <v-card-text class="text-body">
          {{ $t('message.refund_confirm') }}
        </v-card-text>
        <v-card-text>
          <v-text-field :label="$t('message.amount')" outline v-model="refundAmount"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="refunding" outlined elevation="0" color="primary" @click="refund()">{{ $t("message.refund")
            }}</v-btn>
          <v-btn elevation="0" @click="refundConfirmDialog = false">{{ $t('message.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editPaidWithDialog" max-width="600">
      <v-card v-if="transaction" style class="text-xs-left pa-3">
        <v-card-title>{{ $t('message.paid_with') }}</v-card-title>
        <v-card-text>
          <PaymentTypeSelect v-model="transaction.paidWith"></PaymentTypeSelect>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" color="primary" @click="updatePaidWith()">{{ $t("message.update") }}</v-btn>
          <v-btn elevation="0" @click="editPaidWithDialog = false">{{ $t('message.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div style="display:none" ref="print_div" v-if="academy && transaction">
      <div style="font-size: 1.5em;text-align: center;">
        <h2>{{ $t("message.purchase_receipt") }}</h2>
        <h4 style="color:gray">{{ academy.name }}</h4>
        <h4 style="color:gray">{{ academy.address }}</h4>
        <table style="margin-top: 50px; width: 100%">
          <tr>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td style="text-align: right">
              <b>{{ $t("message.transaction") }} #: </b>
            </td>
            <td style="text-align: left">{{ transaction._id }}</td>
          </tr>
          <tr>
            <td style="text-align: right">
              <b>{{ $t("message.date_created") }}: </b>
            </td>
            <td style="text-align: left">
              {{ $d(new Date(created), "long", $i18n.locale) }}
            </td>
          </tr>
          <tr v-if="transaction.user">
            <td style="text-align: right">
              <b>{{ $t("message.processed_by") }}: </b>
            </td>
            <td style="text-align: left">
              {{ transaction.user.fName }} {{ transaction.user.lName }}
            </td>
          </tr>
          <tr>
            <td style="text-align: right">
              <b>{{ $t("message.sold_to") }}: </b>
            </td>
            <td style="text-align: left">
              {{
                transaction.buyer
                  ? transaction.buyer.fName + " " + transaction.buyer.lName
                  : email
              }}
            </td>
          </tr>
          <!-- PRODUCTS -->
          <tr>
            <td style="text-align: right;vertical-align: top">
              <b>{{ $t("message.items") }}: </b>
            </td>
            <td style="text-align: left">
              <table>
                <template v-for="(i, index) in transaction.items">
                  <tr v-if="i.product" :key="'printout_item_' + index">
                    <td style="text-align: left">{{ i.product.name }}</td>
                    <td style="text-align: left"> {{ academy.currencySymbol }}{{ i.amount ? string2Decimal(i.amount) :
                      i.product.amountDecimal }} (x{{ i.quantity }})</td>
                  </tr>
                  <tr v-else :key="'printout_noprod_item_' + index">
                    <td style="text-align: left">{{ i.name }}</td>
                    <td style="text-align: left"> {{ academy.currencySymbol }}{{ i.amount }} (x{{ i.quantity }})</td>
                  </tr>
                </template>
              </table>
            </td>
          </tr>
          <tr v-if="transaction.coupon">
            <td style="text-align: right">
              <b>{{ $t("message.discount") }}:</b>
            </td>
            <td style="text-align: left">
              <span v-if="transaction.coupon.discountPercent">
                {{ transaction.coupon.discountPercent }}%
              </span>
              <span v-if="transaction.coupon.discountAmount">
                {{ academy.currencySymbol }}{{ transaction.coupon.discountAmount }}
              </span>
            </td>
          </tr>
          <tr>
            <td style="text-align: right">
              <b>{{ $t("message.total") }}: </b>
            </td>
            <td style="text-align: left">
              <div v-if="transaction.coupon">
                {{ academy.currencySymbol }}{{ transaction.coupon.discountedTotal }}
              </div>
              <div v-else>
                {{ academy.currencySymbol }}{{ transactionTotal }}
              </div>
            </td>
          </tr>
        </table>
        <hr style="width:100%; color:gray;margin-top:20px">
        <div style="text-align:center" v-if="academyImage">
          <img style="width:60px;height:60px;object-fit:cover;border-radius:50%;" :src="academyImage" />
        </div>
        <div style="text-align:center;color:gray">
          <h5>{{ academy.name }}</h5>
          <h6>{{ academy.address }}</h6>
        </div>
        <div style="text-align: center;margin-top:20px" class="supporting-text">
          <div>Powered by BJJLINK&copy; LLC 2025</div>
          <img style="width:50px;" :src="assets('logo_small.png')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentType from "@/components/displays/PaymentTypeDisplay.vue";
import TransactionIcon from "@/components/displays/TransactionIcon.vue";
import AcademyActivity from "@/components/displays/AcademyActivity.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import MembersAutocomplete from "@/components/inputs/MembersAutocomplete.vue";
import PaymentTypeSelect from "@/components/inputs/PaymentTypeSelect.vue";
import Api from "@/services/Api";

var PHE = require("print-html-element");

export default {
  components: {
    DatePicker,
    TransactionIcon,
    MembersAutocomplete,
    AcademyActivity,
    PaymentType,
    PaymentTypeSelect
  },
  data() {
    return {
      transactionId: this.$route.params.transactionId,
      loading: true,
      transactionDateDialog: null,
      transaction: null,
      isMember: false,
      created: null,
      totalAmount: 0,
      selectedInvoice: null,
      totalRefunded: 0,
      refundAmount: 0,
      refundConfirmDialog: 0,
      amount: null,
      currency: null,
      assignBuyerDialog: false,
      paymentsReady: false,
      assignMemberId: null,
      sendEmailDialog: false,
      altEmail: null,
      refunding: false,
      cancelCashTransactionDialog: false,
      altEmailConfirm: false,
      status: null,
      email: null,
      academy: null,
      isInfinicept: false,
      editPaidWithDialog: null,
      checkoutSession: null,
      transactionTotal: null,
      items: [],
      academyImage: null,
      paymentMethod: null,
      processingPayment: false,
      uploadingMessage: null,
      uploading: false,
      uploadedReceipt: null,
      selectedFile: null,
      receipt: null,
      sendingReminder: false,
      history: []
    };
  },
  created() {
    const now = new Date();
    now.setDate(now.getDate() + 1);
    this.todayString = this.toNiceDateCustomFormatAdjusted(now, "YYYY-MM-DD");
    this.getTransactionData();
    Api()
      .get("admins/academy/" + this.$store.state.selectedAcademy)
      .then((response) => {
        this.academy = response.data;
        this.academyImage = this.userImg(this.academy.image);
      });
    Api()
      .get(
        "admins/academy/" +
        this.$store.state.managedAcademy +
        "/is_connected/stripe"
      )
      .then((response) => {
        this.paymentsReady = response.data.stripeConnected;
      });
  },
  watch: {},
  methods: {
    sendReminder() {
      this.sendingReminder = true;
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/reminder/transaction/" +
          this.transactionId
        )
        .then((response) => {
          if (response) {
            this.sendingReminder = false;
            this.showAlert(
              "success",
              this.$t("message.sent")
            );
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    filePicker() {
      this.$refs.fileUploadInput.click();
    },
    onFileSelect(event) {
      this.uploading = true;
      if (event.target.files[0]) {
        this.receipt = null;
        this.selectedFile = event.target.files[0];
        const size = event.target.files[0].size;
        const sizeMb = Math.floor(size / 1000000);
        if (sizeMb <= 15) {
          this.uploadPhoto();
        } else {
          this.uploading = false;
          this.showAlert(
            "error",
            "Sorry! Your image is too big (" +
            sizeMb +
            "mb), try a smaller one."
          );
        }
      } else {
        this.uploading = false;
      }
    },
    uploadPhoto() {
      const formData = new FormData();
      this.uploadingMessage = this.$t("message.image_upload_progress");
      const d = new Date();
      const millis = d.getTime();
      const imgExtension = this.selectedFile.type.toLowerCase().split('/')[1];
      const blob = new Blob([this.selectedFile], { type: this.selectedFile.type });
      formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.' + imgExtension);
      Api().post("content/image/admin", formData)
        .then(res => {
          const data = res.data;
          if (data) {
            const vm = this;
            setTimeout(function () {
              vm.receipt = data.original;
              vm.uploadedReceipt = data;
              vm.uploadingMessage = null;
              vm.uploading = false;
            }, 4000);
          }
        })
        .catch(() => {
          this.showAlert("error", "Oops!", ":(");
          this.uploading = false;
        });
    },
    updateTransactionReceipt() {
      Api()
        .patch(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transactionId + "/receipt", { receipt: this.uploadedReceipt.location }
        )
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    updatePaidWith() {
      Api()
        .patch(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transactionId + "/paid-with", { paidWith: this.transaction.paidWith }
        )
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
          this.editPaidWithDialog = false;
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    assignBuyer() {
      this.assignBuyerDialog = false;
      Api()
        .patch(
          "payments/managedacademy/" +
          this.$store.state.managedAcademy +
          "/transaction/" +
          this.transactionId + "/buyer/" + this.assignMemberId
        )
        .then(() => {
          this.getTransactionData();
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    getTransactionData() {
      this.loading = true;
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/payments/transactions/" +
          this.transactionId
        )
        .then((response) => {
          this.transaction = response.data.transaction;
          if (this.transaction && this.transaction.buyer && !this.transaction.completed) {
            this.getPaymentMethod();
          }
          this.checkoutSession = response.data.session;
          this.email = this.transaction.email;
          if (response.data.isMember) {
            this.isMember = true;
          }
          this.receipt = this.transaction.receipt;
          if (!this.email) {
            if (!this.transaction.buyer)
              this.email = response.data.session.customer_email;
            else this.email = this.transaction.buyer.email;
          }
          this.altEmail = this.email;
          this.product = response.data.product;
          this.created = response.data.transaction.time;
          this.amount = response.data.transaction.amount;
          this.transactionTotal = response.data.transaction.amount;
          this.currency = response.data.transaction.currency;
          if (response.data.session && response.data.session.status)
            this.status = response.data.session.status;
          this.loading = false;
          if (this.transaction.paymentsModule == 'infinicept')
            this.isInfinicept = true;
          this.totalAmount = this.transaction.amount * this.transaction.quantity
          if (this.transaction.refunds && this.transaction.refunds.length > 0) {
            this.totalRefunded = 0;
            for (const t of this.transaction.refunds) {
              this.totalRefunded += t.amount;
            }
          }
          this.history = response.data.history;
          if (this.transaction.completed && !this.transaction.cancelled) {
            if (this.isInfinicept)
              this.selectedInvoice = this.transaction._id;
            else
              this.selectedInvoice = response.data.paymentIntent ? response.data.paymentIntent.id : null;
          }
        });
    },
    getPaymentMethod() {
      Api()
        .get(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/customer/" +
          this.transaction.buyer._id
        )
        .then((response) => {
          if (response.data && response.data.paymentMethod) {
            this.paymentMethod = response.data.paymentMethod;
            let expDate = new Date();
            expDate.setFullYear(this.paymentMethod.expYear);
            expDate.setMonth(this.paymentMethod.expMonth - 1);
            this.paymentMethod.expDate = expDate;
            let today = new Date();
            if (expDate > today) this.paymentMethod.expired = false;
            else this.paymentMethod.expired = true;
          } else {
            this.paymentMethod = null;
          }
        });
    },
    refund() {
      if (!this.selectedInvoice) {
        return;
      }
      this.refunding = true;
      let data = {
        amount: this.refundAmount,
        transaction: this.transactionId,
      };
      Api()
        .patch(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/refund/" +
          this.selectedInvoice,
          data
        )
        .then((response) => {
          if (response.data) {
            this.showAlert("success", this.$t("message.success"));
            this.selectedInvoice = null;
            this.refundConfirmDialog = false;
            this.getTransactionData();
            this.refunding = false;
          }
        })
        .catch((err) => {
          this.showAlert("error", err.response.data.message);
        });
    },
    showRefundDialog(invoice) {
      if (invoice) {
        this.selectedInvoice = invoice.paymentIntent;
        this.refundAmount = invoice.amountPaid;
      } else {
        this.refundAmount = this.amount * this.transaction.quantity
      }
      this.refundConfirmDialog = true;
    },
    updateTransactionDate() {
      Api()
        .patch(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transactionId + "/date", { date: this.created }
        )
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
          this.transactionDateDialog = false;
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    goToEvent(event) {
      this.navigateTo({
        name: "manageacademyevent",
        params: { eventId: event._id },
      });
    },
    checkMemberAndGo() {
      if (this.transaction.buyer) {
        this.goToMember(this.transaction.buyer._id, this.transaction.buyer.displayName);
      }
    },
    removeCashTransaction() {
      Api()
        .delete(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/cash/" +
          this.transactionId
        )
        .then((response) => {
          if (response) this.navigateTo({ name: "transactions" });
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    cancelOneTimePayment() {
      Api()
        .delete(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transactionId
        )
        .then((response) => {
          if (response) {
            this.navigateTo({ name: "transactions" });
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    getStatusColor() {
      if (this.status) {
        if (this.status == "active" || this.status == "paid") this.themeColor("success");
        else if (this.status == "pending_payment") return this.themeColor("error");
        else if (this.status == "trialing") return this.themeColor("gold");
        //getStatusColor
        else return "red";
      } else {
        if (this.transaction.cancelled) return this.themeColor("error");
        if (this.transaction.completed) return this.themeColor("success");
        else return this.themeColor("error");
      }
    },
    updateTransactionNotes() {
      Api()
        .patch(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transactionId + "/notes", { notes: this.transaction.notes }
        )
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    canCompletePayment() {
      const t = this.transaction;
      if (t.processedBy == "desk" || t.processedBy == "user") {
        if (!t.completed &&
          !t.cancelled)
          return true;
      }
      return false;
    },
    completePaymentCash() {
      if (this.processingPayment)
        return;
      this.processingPayment = true;
      Api()
        .post(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transaction._id + "/onetime/cash"
        )
        .then(() => {
          this.loading = true;
          this.processingPayment = false;
          this.paymentMethod = null;
          this.transaction.completed = new Date();
          this.status = 'paid';
          this.transaction.paidWithCash = true;
          this.loading = false;
          this.$router.go();
          this.showAlert("success", this.$t("message.success"));
        })
        .catch(() => {
          this.processingPayment = false;
          this.showAlert("error", "Declined");
        });
    },
    completePaymentSavedCard() {
      if (this.processingPayment)
        return;
      //"/academy/:managedAcademyId/transactions/:transactionId/onetime/savedcard"
      this.processingPayment = true;
      Api()
        .post(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/" +
          this.transaction._id + "/onetime/savedcard"
        )
        .then(() => {
          this.loading = true;
          this.processingPayment = false;
          this.paymentMethod = null;
          this.transaction.completed = new Date();
          this.status = 'paid';
          this.loading = false;
          this.showAlert("success", this.$t("message.success"));
        })
        .catch((err) => {
          console.log(err)
          this.processingPayment = false;
          this.showAlert("error", "Declined");
        });
    },
    completePayment() {
      if (this.transaction.paymentsModule == 'infinicept') {
        const postData = { routeFrom: 'viewitemstransaction', transactionId: this.transactionId };
        this.navigateTo({
          name: "inifnicept-checkout",
          params: { transactionData: postData, transactionId: this.transactionId }
        });
      } else {
        if (this.transaction.stripeAccountId) {
          this.navigateTo({
            name: 'striperedirect_transaction',
            params: { transactionId: this.transactionId },
            query: { altStripeAccount: this.transaction.stripeAccountId }
          })
        } else {
          this.navigateTo({
            name: 'striperedirect_transaction',
            params: { transactionId: this.transactionId },
          })
        }
      }
    },
    getPaymentStatus() {
      if (this.transaction.cancelled) {
        if (this.transaction.subscription) return this.$t("message.inactive");
        else return this.$t("message.cancelled");
      } else if (this.transaction.completed) {
        if (this.transaction.subscription) {
          if (this.status && this.status == "trialing")
            return this.$t("message.waiting_to_start");
          else return this.$t("message.active");
        } else if (this.status) {
          return this.status;
        } else {
          return this.$t("message.paid");
        }
      } else {
        return this.$t("message.waiting_for_payment");
      }
    },
    emailReceipt() {
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/payments/transactions/" +
          this.transaction._id + "/email/receipt/", { email: this.altEmail }
        )
        .then((response) => {
          if (response) {
            this.sendEmailDialog = false;
            this.showAlert("info", this.$t("message.email_sent"));
          }
        });
    },
    printReceipt() {
      var p = this.$refs.print_div;
      PHE.printHtml(p.innerHTML);
    },
    isPending() {
      const s = this.transaction;
      if (s.payment_intent) {
        if (s.payment_intent.status == "requires_payment_method") return true;
      } else return false;
    },
  },
};
</script>

<style scoped></style>
